module.exports = __webpack_public_path__ + "img/音乐12.4cd740a9.png";